<template>
  <el-dialog
    title="Change Password"
    :visible.sync="innerVisible"
    width="440px"
    append-to-body
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="88px" size="small" @submit.native.prevent="submit">
      <el-form-item label="Current" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password" show-password autocomplete="off" placeholder="Please enter your current password" />
      </el-form-item>
      <el-form-item label="New" prop="newPassword">
        <el-input v-model="form.newPassword" type="password" show-password autocomplete="new-password" placeholder="At least 6 characters" />
      </el-form-item>
      <el-form-item label="Confirm" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" show-password autocomplete="new-password" placeholder="Re-enter the new password" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="innerVisible = false">Cancel</el-button>
      <el-button type="primary" :loading="loading" @click="submit">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { authApi } from '@/api/auth'

export default {
  name: 'HeaderChangePasswordDialog',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('The two new passwords do not match'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: { oldPassword: '', newPassword: '', confirmPassword: '' },
      rules: {
        oldPassword: [{ required: true, message: 'Please enter your current password', trigger: 'blur' }],
        newPassword: [
          { required: true, message: 'Please enter a new password', trigger: 'blur' },
          { min: 6, message: 'The new password must be at least 6 characters', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: 'Please re-enter the new password', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    innerVisible: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) }
    }
  },
  methods: {
    resetForm() {
      this.form = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await authApi.changePassword({
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword
          })
          this.$message.success('Password changed successfully. Please sign in again.')
          this.innerVisible = false
          this.$emit('success')
        } catch (e) {
          /* request interceptor handles message */
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
